// Браузер не поддерживает timers/promise - это нодовская фича
export async function sleep(ms: number) {
	return new Promise(done => setTimeout(done, ms));
}
